import React from 'react';
import classnames from 'classnames';

import {ACUD_PRO_PREFIX} from '../../../_common/constants';

import './index.less';

const DESC_PREFIX_CLS = `${ACUD_PRO_PREFIX}-page-layout__desc`;

export interface DescProps {
    children: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
}

export interface DescInterface extends React.FC<DescProps> {}

const Desc: DescInterface = props => {
    const {className, style} = props;

    const descCls = classnames(DESC_PREFIX_CLS, className);

    return (
        <div className={descCls} style={style} {...props}>
            {props.children}
        </div>
    );
};

export default Desc;